var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F45369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.479 14.38H8.52a1.53 1.53 0 0 0-1.52 1.536c0 .85.68 1.703 1.52 1.703H23.48c.84 0 1.521-.854 1.521-1.703a1.53 1.53 0 0 0-1.521-1.537ZM8.52 12.22H23.48c.84 0 1.521-.855 1.521-1.704A1.53 1.53 0 0 0 23.48 8.98H8.52a1.53 1.53 0 0 0-1.52 1.538c0 .848.68 1.703 1.52 1.703Zm14.958 7.56H8.52a1.53 1.53 0 0 0-1.52 1.537c0 .848.68 1.703 1.52 1.703H23.48c.84 0 1.521-.855 1.521-1.703a1.53 1.53 0 0 0-1.521-1.538Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu-btn.3ef033cbb574e85889508b1bcc78cd0a.svg";